module.exports = ".stat-group{\r\n  cursor: pointer;\r\n}\r\n.stat-group *{\r\n  cursor: pointer;\r\n}\r\n"